import { AxiosError } from 'axios';

import { City, CountryState, ZipCodeResult } from './country.type';

export const getCountries = async () => {
  return await apiClient().get<CountryState[]>('/country-state/countries');
};

export const getStatesByCountry = async (countrySlug: string) => {
  return await apiClient().get<CountryState[]>(`/country-state/states/${countrySlug}`);
};

export const getCitiesByZipCode = async (countryCode: string, zipCode: string) => {
  return await apiClient().get<City>('/country-state/cities', {
    params: {
      countryCode,
      zipCode,
    },
  });
};

export async function checkZipCode(countryCode: string, zipCode: string) {
  try {
    const res = await apiClient().get<ZipCodeResult>('/listing/check-zip-code', {
      params: { countryCode, zipCode },
      errorHandling: 'throwOnly',
    });

    return res;
  } catch (error) {

    if (error instanceof AxiosError) {
      return { success: false, data: null, message: error.response?.data.message };
    }

    return { success: false, data: null, message: (error as Error).message };
  }
}
